import { cn } from "../../lib/cn";

const LOGO_W = 55;
const LOGO_H = 12;

/** Footer wordmark – fixed pixel box matches 161.2×35 aspect ratio at h-3. */
export function SeelayLogo({ className, alt = "Seelay", ...props }) {
  return (
    <img
      src="/seelay-logo.svg"
      alt={alt}
      width={LOGO_W}
      height={LOGO_H}
      loading="eager"
      className={cn("block shrink-0 object-contain", className)}
      style={{ width: LOGO_W, height: LOGO_H }}
      {...props}
    />
  );
}
